export default function ConfirmationDialog({ data, onClose}) {
    const { message, onConfirm, onCancel, cancel, confirm, icon } = data;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
            <div className="bg-white rounded-xl p-6 w-[330px] shadow-xl">

                {/* Icon (optional) */}
                {icon && (
                    <div className="flex justify-center mb-4">
                        {icon}
                    </div>
                )}

                <p className="text-gray-800 mb-5 text-center">
                    {message}
                </p>

                <div className="flex justify-center gap-3">
                    {
                        cancel && (<button
                            className="w-full px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                            onClick={() => {
                                onCancel?.();
                                onClose();
                            }}
                        >
                            {cancel || "Cancel"}
                        </button>)
                    }

                    <button
                        className="w-full px-4 py-2 rounded-lg bg-lime-700 text-white hover:bg-lime-800"
                        onClick={() => {
                            onConfirm?.();
                            onClose();
                        }}
                    >
                        { confirm || "Confirm" }
                    </button>
                </div>
            </div>
        </div>
    );
}
